module.exports = __webpack_public_path__ + "static/media/toilet-state-3.76e63998.wav";